// extracted by mini-css-extract-plugin
module.exports = {"appNavLink":"AppNavLink_appNavLink__2mILC","navLink":"AppNavLink_navLink__dgjMb","collapse":"AppNavLink_collapse__1MA8S","navbar-collapse":"AppNavLink_navbar-collapse__TTzON"};